import '../../style';
import './index.less';



// WEBPACK FOOTER //
// ./components/loading-placeholder/style/index.tsx